import { EntityType } from '@frontend/common';
import { ErrorHandler } from '@frontend/error-handler';
import { IdentificationClient } from '@frontend/identification/api';
import { CreateIdentification, Identification, IdentificationType } from '@frontend/identification/types';
import { CommonMessage } from '@frontend/lang';
import { useAccountRepository } from '@frontend/repository';
import { ToastUtil } from '@frontend/toast-utils';
import { FormattedMessage } from 'react-intl';

import UpdateModal from '../../../../modal/update-modal/update-modal.component';

export interface BadgeUpdateProps {
    entity_id: string;
    onSubmitSuccess?: (value: Identification) => void;
}

export const BadgeCreate = (props: BadgeUpdateProps) => {
    const { currentAccount } = useAccountRepository();
    return (
        <UpdateModal<Identification, CreateIdentification>
            order={['key']}
            values={{ key: undefined, type: IdentificationType.BADGE, entity_id: props.entity_id, entity_type: EntityType.USER }}
            keyOverwrite={new Map([['key', CommonMessage.OBJECTS.BADGE.DEFAULT]])}
            onSubmit={(value) => IdentificationClient.postIdentification(currentAccount, value)}
            type={EntityType.IDENTIFICATION}
            label={
                <FormattedMessage
                    id='badge.create.title'
                    defaultMessage='Create badge'
                />
            }
            onSubmitSuccess={props.onSubmitSuccess}
            successMessageOverwrite={
                <FormattedMessage
                    id='badge.create.success'
                    defaultMessage='Badge created successfully'
                />
            }
            errorMessageOverwrite={(error) => {
                switch (error.code) {
                    case 409:
                        return ToastUtil.error(
                            CommonMessage.TOAST.PROMISE.ERROR,
                            <FormattedMessage
                                id='badge.create.error.conflict'
                                defaultMessage='A badge with this key is already linked to a user'
                            />
                        );
                    default:
                        return ErrorHandler.handleError({ error: error, entity_type: EntityType.BADGE });
                }
            }}
        />
    );
};
